<template>
  <div class="comments__list">
    <Comment
      class="list__comment"
      v-for="(item, index) in commentList"
      :class="`comment_id_${item.id}`"
      :ref="item.id"
      :key="index"
      :comment="item"
      @editComment="editComment"
      @deleteComment="deleteComment"
      :userId="userId"
    />
    <div v-if="commentList.length === 0">
      <Alert v-if="hasNoRights" text="Нет прав на просмотр комментариев" />
      <Alert v-else text="Комментариев еще нет" />
    </div>
  </div>
</template>
<script>
import Comment from './Comment.vue';
import { store } from '@/store';
import Alert from 'Elements/Alert/Alert';

export default {
  components: { Comment, Alert },
  name: 'comment-list',
  props: {
    commentList: Array,
    userId: String,
    mode: {
      type: String,
      default: 'default'
    }
  },
  created() {
    if (
      this.$router.currentRoute.name === 'commentId' ||
      this.$router.currentRoute.name === 'commentIdVacancy' ||
      this.$router.currentRoute.name === 'commentIdCoordination' ||
      this.$router.currentRoute.name === 'commentIdCoordinationRequest'
    ) {
      this.$nextTick(() => {
        const commentId = this.$router.currentRoute.params.commentId;
        if (commentId) {
          const el = document.querySelector(`.comment_id_${commentId}`);
          el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    }
  },
  computed: {
    hasNoRights() {
      return store.state.subpanels.hasNoRights;
    }
  },
  methods: {
    editComment(comment) {
      this.$emit('editComment', comment);
    },
    deleteComment(comment) {
      this.$emit('deleteComment', comment);
    }
  }
};
</script>
<style lang="scss" scoped>
.empty {
  height: 100%;

  &-selection {
    min-height: 254px !important;
  }
}

.selection {
  max-height: 254px;
}

.comments__list {
  display: flex;
  flex-direction: column;
  background: $white;

  &_empty {
    height: 100%;
  }
}

.list__comment {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
